var config = {
  intro : {
    isFullScreenHeader : true,
    isWhiteLogo : false,
    fullBgImage : false, // '' or false = no background. Also useful if you are showing a video (kind of poster)
    showCalltoaction : false,
    isFixedNav: false
  },
  controls: {
    showInfo: false,
    showTopButton : false,
    showMuteButton : false
  },
  map: {
    // general 
    center: [52.073757,9.5377483],
    options: {
      scrollWheelZoom: false,
      zoomControl: false,
      minZoom: 3,
      maxZoom:10
    },
    tileLayer: 'https://maps.tilehosting.com/c/a0a037d7-f288-42a8-88cf-666cf06cee7a/styles/basemap-berlin-4f0b1/{z}/{x}/{y}@2x.png?key=68ErAz6zqgdV9jEjhpuz',
    attribution: 'Map data &copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/"">CC-BY-SA</a>, Imagery © <a href="https://maptiler.com">MapTiler</a>',
    labels: [
      ['Baden-Württemberg', 8.602314,48.832237],
      ['Bayern', 11.423220228573216,48.946895101414931],
      ['Berlin', 13.368151,52.532701],
      ['Brandenburg', 13.029619,52.147052],
      ['Bremen', 8.786234507920813,53.112144339557489],
      ['Hamburg', 10.027208746556367,53.554568183845632],
      ['Hessen', 8.659773,50.804256],
      ['Mecklenburg-Vorpommern', 12.537583851741839,53.753120209775368],
      ['Niedersachsen', 9.468131,52.661918],
      ['Nordrhein-Westfalen', 7.219533,51.496297],
      ['Rheinland-Pfalz', 6.654691, 50.179671],
      ['Saarland', 6.957027344167741,49.386627021460711],
      ['Sachsen-Anhalt', 11.056544,51.843087],
      ['Sachsen', 13.303364,51.155872],
      ['Schleswig-Holstein', 9.109166, 54.261276],
      ['Thüringen', 11.030484566238968,50.902974966987735]
    ]
  }
};

module.exports = config;